import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './jslib/element-ui'
import './jslib/components' // 自定義組件

import '@assets/css/common.scss'
import '@assets/css/reset-element.scss'   // 重寫element-ui組件樣式
import 'element-ui/lib/theme-chalk/index.css'

import '@/jslib/quill-editor'

import './jslib/fontawesom' // 圖標庫

import './jslib/directive'

import i18n from '@jslib/i18n'
Vue.use(i18n)

import '@/mixins/global'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
